// extracted by mini-css-extract-plugin
export default {"card":"MQj2jIO5","header":"xmkd4EXx","type":"k6dKii4K","name":"Zjj9P_lE","description":"DtQXbgnj","footer":"GWzhnLu5","priority":"KkVEHZqh"};